import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Button.css";

const Button = ({ onClick, label, disabled, className }) => {
  return (
    <button
      type="button"
      className={classNames(
        "Button__Container",
        {
          Button__Disabled: disabled,
        },
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

Button.defaultProps = {
  onClick: () => {},
};

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export { Button };
